// Partner network (shown on /partners and used for the homepage marquee fallback).
// Logos: the owner uploads official logo files to frontend/public/partners/<slug>.png
// (or adds them as featured images on partner posts in WordPress). Until a logo
// file exists, the partner's name renders as styled text — nothing looks broken.
const slugify = (n) => n.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const PARTNER_GROUPS = [
  {
    id: "psb",
    title: "Public Sector Banks",
    note: "We work with India's twelve public sector banks, including:",
    names: ["State Bank of India", "Bank of Baroda", "Canara Bank", "Punjab National Bank", "Union Bank of India", "Bank of India"],
  },
  {
    id: "private",
    title: "Private Sector Banks",
    note: "India's major private-sector lenders:",
    names: ["HDFC Bank", "ICICI Bank", "Axis Bank", "Bandhan Bank", "IDBI Bank", "IndusInd Bank", "Yes Bank"],
  },
  {
    id: "mnc",
    title: "MNC Banks in India",
    note: "Prominent multinational banks operating in India:",
    names: ["HSBC Bank India", "Standard Chartered Bank", "Deutsche Bank", "DBS Bank India"],
  },
];

export const ALL_PARTNERS = PARTNER_GROUPS.flatMap((g) => g.names).map((name) => ({
  name,
  initials: name.split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase(),
  slug: slugify(name),
  logo: `/partners/${slugify(name)}.png`,
}));

export const ALL_PARTNER_NAMES = ALL_PARTNERS.map((p) => p.name);
